<template>
    <div
        :sawline-id="sawline.ID"
        v-if="sawlineOperationOptions && flyScreenColors"
    >
        <pre
            class="debug"
            v-if="isDebug"
            >{{ children }}</pre
        >
        <pre
            class="debug"
            v-if="isDebug"
            >{{ sawline }}</pre
        >
        <div
            class="sawline-edit"
            :class="{
                'open-item': sawline == selectedLine,
                ...anyError($v.sawline),
            }"
            v-show="shouldShowSawline(sawline)"
        >
            <template v-if="sawline.removed">
                <div v-if="sawline.ID">
                    verwijderde zaaglijn #{{ sawline.ID }} (
                    <a @click="sawline.removed = false">herstellen</a>
                    )
                </div>
                <div v-else>
                    verwijderde nieuwe zaaglijn (
                    <a @click="sawline.removed = false">herstellen</a>
                    )
                </div>
            </template>
            <template v-else-if="sawline == selectedLine">
                <div class="first-row">
                    <div class="field-grid external-name">
                        <ui5-input
                            :class="hasError($v.sawline.externalName)"
                            type="Text"
                            :value="sawline.externalName"
                            @input="sawline.externalName = $event.target.value"
                        />
                        <div
                            v-if="
                                getErrorFromValidator($v.sawline.rightEnd)
                                    .length
                            "
                            class="error"
                        >
                            {{ getErrorFromValidator($v.sawline.rightEnd) }}
                        </div>
                    </div>
                    <div class="field-grid">
                        <div class="v-select-container">
                            <v-select
                                :class="hasError($v.sawline.profile)"
                                :clearable="false"
                                :options="profileOptions"
                                :value="
                                    profileOptions.find(
                                        (x) => x.value == sawline.profile
                                    )
                                "
                                @input="sawline.profile = $event.value"
                            />
                            <div
                                v-if="
                                    getErrorFromValidator($v.sawline.profile)
                                        .length
                                "
                                class="error"
                            >
                                {{ getErrorFromValidator($v.sawline.profile) }}
                            </div>
                        </div>
                    </div>
                    <div class="field-grid">
                        <div class="v-select-container">
                            <v-select
                                :value="
                                    profileDatafieldOptions.find(
                                        (x) =>
                                            x.value == sawline.profileDatafield
                                    )
                                "
                                :class="hasError($v.sawline.profileDatafield)"
                                :clearable="false"
                                :options="profileDatafieldOptions"
                                :disabled="sawline.profile !== null"
                                @input="
                                    $set(
                                        sawline,
                                        'profileDatafield',
                                        $event.value
                                    )
                                "
                            />
                            <div
                                v-if="
                                    getErrorFromValidator(
                                        $v.sawline.profileDatafield
                                    ).length
                                "
                                class="error"
                            >
                                {{
                                    getErrorFromValidator(
                                        $v.sawline.profileDatafield
                                    )
                                }}
                            </div>
                        </div>
                    </div>
                    <div class="field-grid">
                        <text-input
                            :class="hasError($v.sawline.leftEnd)"
                            type="number"
                            min="0"
                            v-model="sawline.leftEnd"
                        />
                        <div
                            v-if="
                                getErrorFromValidator($v.sawline.leftEnd).length
                            "
                            class="error"
                        >
                            {{ getErrorFromValidator($v.sawline.leftEnd) }}
                        </div>
                    </div>
                    <div class="field-grid">
                        <text-input
                            :class="hasError($v.sawline.rightEnd)"
                            type="number"
                            min="0"
                            v-model="sawline.rightEnd"
                        />
                        <div
                            v-if="
                                getErrorFromValidator($v.sawline.rightEnd)
                                    .length
                            "
                            class="error"
                        >
                            {{ getErrorFromValidator($v.sawline.rightEnd) }}
                        </div>
                    </div>
                </div>
                <div class="second-row">
                    <div class="left-settings">
                        <div class="field-grid">
                            <ui5-select
                                class="datafield-selector"
                                :class="hasError($v.sawline.datafield)"
                                @change="
                                    sawline.datafield =
                                        $event.detail.selectedOption.value
                                "
                            >
                                <ui5-option
                                    v-for="option in dataFieldOptions"
                                    :key="option.value"
                                    :selected="
                                        option.value == sawline.datafield
                                    "
                                    :value="option.value"
                                >
                                    {{ option.label }}
                                </ui5-option>
                            </ui5-select>
                            <div
                                v-if="
                                    getErrorFromValidator($v.sawline.datafield)
                                        .length
                                "
                                class="error"
                            >
                                {{
                                    getErrorFromValidator($v.sawline.datafield)
                                }}
                            </div>
                        </div>
                        <div class="field-grid">
                            <ui5-select
                                :class="hasError($v.sawline.addition)"
                                @change="
                                    sawline.addition =
                                        $event.detail.selectedOption.value
                                "
                            >
                                <ui5-option
                                    v-for="option in sawlineOperationOptions"
                                    :key="option.value"
                                    :selected="option.value == sawline.addition"
                                    :value="option.value"
                                >
                                    {{ option.label }}
                                </ui5-option>
                            </ui5-select>
                            <div
                                v-if="
                                    getErrorFromValidator($v.sawline.addition)
                                        .length
                                "
                                class="error"
                            >
                                {{ getErrorFromValidator($v.sawline.addition) }}
                            </div>
                        </div>
                        <div class="field-grid">
                            <ui5-input
                                :class="hasError($v.sawline.constant)"
                                type="Text"
                                @input="sawline.constant = $event.target.value"
                                :value="sawline.constant"
                            />
                            <div
                                v-if="
                                    getErrorFromValidator($v.sawline.constant)
                                        .length
                                "
                                class="error"
                            >
                                {{ getErrorFromValidator($v.sawline.constant) }}
                            </div>
                        </div>
                        <div class="field-grid">
                            <text-input
                                :class="hasError($v.sawline.offset)"
                                type="number"
                                placeholder="Totale offset"
                                min="1"
                                :disabled="
                                    sawline.addition !=
                                    sawlineOperationOptions.find(
                                        (x) => x.label == 'incr'
                                    ).value
                                "
                                v-model="sawline.offset"
                            />
                            <div
                                v-if="
                                    getErrorFromValidator($v.sawline.offset)
                                        .length
                                "
                                class="error"
                            >
                                {{ getErrorFromValidator($v.sawline.offset) }}
                            </div>
                        </div>
                        <div class="field-grid">
                            <text-input
                                :class="hasError($v.sawline.divideBy)"
                                type="number"
                                placeholder="Resultaat delen door"
                                min="1"
                                v-model="sawline.divideBy"
                            />
                            <div
                                v-if="
                                    getErrorFromValidator($v.sawline.divideBy)
                                        .length
                                "
                                class="error"
                            >
                                {{ getErrorFromValidator($v.sawline.divideBy) }}
                            </div>
                        </div>
                        <div class="field-grid">
                            <ui5-select
                                :class="hasError($v.sawline.unit)"
                                @change="
                                    sawline.unit =
                                        $event.detail.selectedOption.value
                                "
                            >
                                <ui5-option
                                    v-for="option in unitOptions"
                                    :selected="option.value == sawline.unit"
                                    :key="option.value"
                                    :value="option.value"
                                >
                                    {{ option.label }}
                                </ui5-option>
                            </ui5-select>
                            <div
                                v-if="
                                    getErrorFromValidator($v.sawline.unit)
                                        .length
                                "
                                class="error"
                            >
                                {{ getErrorFromValidator($v.sawline.unit) }}
                            </div>
                        </div>
                    </div>
                    <div class="right-settings">
                        <ui5-label>{{ labels.datafieldCNC }}:</ui5-label>
                        <div class="field-grid">
                            <ui5-select
                                class="datafield-selector"
                                :class="hasError($v.sawline.datafieldCNC)"
                                @change="
                                    sawline.datafieldCNC =
                                        $event.detail.selectedOption.value
                                "
                            >
                                <ui5-option
                                    :value="null"
                                    :selected="null == sawline.datafieldCNC"
                                >
                                    ---geen dataveld---
                                </ui5-option>
                                <ui5-option
                                    v-for="option in dataFieldOptions"
                                    :key="option.value"
                                    :selected="
                                        option.value == sawline.datafieldCNC
                                    "
                                    :value="option.value"
                                >
                                    {{ option.label }}
                                </ui5-option>
                            </ui5-select>
                            <div
                                v-if="
                                    getErrorFromValidator(
                                        $v.sawline.datafieldCNC
                                    ).length
                                "
                                class="error"
                            >
                                {{
                                    getErrorFromValidator(
                                        $v.sawline.datafieldCNC
                                    )
                                }}
                            </div>
                        </div>
                        <div class="field-grid">
                            <ui5-select
                                :class="hasError($v.sawline.additionCNC)"
                                @change="
                                    sawline.additionCNC =
                                        $event.detail.selectedOption.value
                                "
                            >
                                <ui5-option
                                    v-for="option in sawlineOperationOptions"
                                    :key="option.value"
                                    :selected="
                                        option.value == sawline.additionCNC
                                    "
                                    :value="option.value"
                                >
                                    {{ option.label }}
                                </ui5-option>
                            </ui5-select>
                            <div
                                v-if="
                                    getErrorFromValidator(
                                        $v.sawline.additionCNC
                                    ).length
                                "
                                class="error"
                            >
                                {{
                                    getErrorFromValidator(
                                        $v.sawline.additionCNC
                                    )
                                }}
                            </div>
                        </div>
                        <div class="field-grid">
                            <ui5-input
                                :class="hasError($v.sawline.constantCNC)"
                                type="text"
                                @input="
                                    sawline.constantCNC = $event.target.value
                                "
                                :value="sawline.constantCNC"
                            />
                            <div
                                v-if="
                                    getErrorFromValidator(
                                        $v.sawline.constantCNC
                                    ).length
                                "
                                class="error"
                            >
                                {{
                                    getErrorFromValidator(
                                        $v.sawline.constantCNC
                                    )
                                }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="third-row">
                    <ui5-label>
                        {{
                            sawline.sawgroup
                                ? sawGroupNames[sawline.sawgroup]
                                : ''
                        }}
                    </ui5-label>
                    <!--
                        <div class="field-grid">
                            <ui5-checkbox
                                :class="hasError($v.sawline.addBoorCorrection)"
                                :checked="sawline.addBoorCorrection == 1"
                                @change="
                                    sawline.addBoorCorrection = $event.target
                                        .checked
                                        ? '1'
                                        : '0'
                                " />
                            <ui5-label>{{ labels.addBoorCorrection }}</ui5-label>
                            <div
                                v-if="
                                    getErrorFromValidator(
                                        $v.sawline.addBoorCorrection
                                    ).length
                                "
                                class="error">
                                {{
                                    getErrorFromValidator(
                                        $v.sawline.addBoorCorrection
                                    )
                                }}
                            </div>
                        </div>
                    -->
                    <div class="field-grid">
                        <ui5-label>{{ labels.useOnProductlists }}</ui5-label>
                        <ui5-multi-combobox
                            @selectionChange="
                                sawline.productlistDefinitionIds =
                                    $event.detail.items.map((x) =>
                                        parseInt(x.getAttribute('val'))
                                    )
                            "
                            placeholder="Kies bontypes"
                            allow-custom-values
                        >
                            <ui5-mcb-item
                                v-for="option in productlistDefinitionOptions"
                                :val="option.value"
                                :selected="
                                    sawline.productlistDefinitionIds.includes(
                                        option.value
                                    )
                                "
                                :key="
                                    'productlistDefinitionOptions.' +
                                    option.value
                                "
                                :text="option.label"
                            ></ui5-mcb-item>
                        </ui5-multi-combobox>
                    </div>

                    <div class="field-grid">
                        <ui5-checkbox
                            :class="hasError($v.sawline.showPaintlist)"
                            :checked="sawline.showPaintlist == 1"
                            :title="showPaintlist_tooltip"
                            @change="
                                sawline.showPaintlist = $event.target.checked
                                    ? '1'
                                    : '0'
                            "
                        />
                        <ui5-label :title="showPaintlist_tooltip">{{ labels.showPaintlist }}</ui5-label>
                        <div
                            v-if="
                                getErrorFromValidator($v.sawline.showPaintlist)
                                    .length
                            "
                            class="error"
                        >
                            {{
                                getErrorFromValidator($v.sawline.showPaintlist)
                            }}
                        </div>
                    </div>
                    <div class="field-grid">
                        <ui5-checkbox
                            :class="hasError($v.sawline.showSawlist)"
                            :checked="sawline.showSawlist == 1"
                            :title="showSawlist_tooltip"
                            @change="
                                sawline.showSawlist = $event.target.checked
                                    ? '1'
                                    : '0'
                            "
                        />
                        <ui5-label :title="showSawlist_tooltip">{{ labels.showSawlist }}</ui5-label>
                        <div
                            v-if="
                                getErrorFromValidator($v.sawline.showSawlist)
                                    .length
                            "
                            class="error"
                        >
                            {{ getErrorFromValidator($v.sawline.showSawlist) }}
                        </div>
                    </div>
                    <div class="field-grid">
                        <ui5-checkbox
                            :class="hasError($v.sawline.add_sawcut_margin)"
                            :checked="sawline.add_sawcut_margin == 1"
                            @change="
                                sawline.add_sawcut_margin = $event.target.checked
                                    ? '1'
                                    : '0'
                            "
                        />
                        <ui5-label>{{ labels.add_sawcut_margin }}</ui5-label>
                        <div
                            v-if="
                                getErrorFromValidator($v.sawline.add_sawcut_margin)
                                    .length
                            "
                            class="error"
                        >
                            {{ getErrorFromValidator($v.sawline.add_sawcut_margin) }}
                        </div>
                    </div>
                    <div class="field-grid">
                        <ui5-checkbox
                            :class="hasError($v.sawline.showSawlist)"
                            :checked="sawline.show_fly_screen == 1"
                            :title="show_fly_screen_tooltip"
                            @change="
                                sawline.show_fly_screen = $event.target.checked
                                    ? '1'
                                    : '0'
                            "
                        />
                        <ui5-label :title="show_fly_screen_tooltip">{{ labels.show_fly_screen }}</ui5-label>
                        <div
                            v-if="
                                getErrorFromValidator(
                                    $v.sawline.show_fly_screen
                                ).length
                            "
                            class="error"
                        >
                            {{
                                getErrorFromValidator(
                                    $v.sawline.show_fly_screen
                                )
                            }}
                        </div>
                    </div>
                    <div class="field-grid cnc-program-field">
                        <ui5-label>{{ labels.cnc }}</ui5-label>
                        <ui5-input
                            :class="hasError($v.sawline.cnc)"
                            type="text"
                            :value="sawline.cnc"
                            @input="sawline.cnc = $event.target.value"
                        />
                        <div
                            v-if="getErrorFromValidator($v.sawline.cnc).length"
                            class="error"
                        >
                            {{ getErrorFromValidator($v.sawline.cnc) }}
                        </div>
                    </div>
                </div>
                <div class="fourth-row">
                    <div class="field-grid">
                        <ui5-label>{{ labels.fly_screen_color }}</ui5-label>
                        <color-select
                            :disabled="sawline.show_fly_screen == 0"
                            :colors="flyScreenColors"
                            :selected-value="sawline.fly_screen_color"
                            @change="
                                sawline.fly_screen_color =
                                    $event.detail.selectedOption.value
                            "
                        />
                        <div
                            v-if="
                                getErrorFromValidator(
                                    $v.sawline.fly_screen_color
                                ).length
                            "
                            class="error"
                        >
                            {{
                                getErrorFromValidator(
                                    $v.sawline.fly_screen_color
                                )
                            }}
                        </div>
                    </div>
                    <div class="field-grid">
                        <ui5-label>{{ labels.fly_screen_order }}:</ui5-label>
                        <text-input
                            :disabled="sawline.show_fly_screen == 0"
                            :class="hasError($v.sawline.fly_screen_order)"
                            type="number"
                            min="0"
                            v-model="sawline.fly_screen_order"
                        />
                        <div
                            v-if="
                                getErrorFromValidator(
                                    $v.sawline.fly_screen_order
                                ).length
                            "
                            class="error"
                        >
                            {{
                                getErrorFromValidator(
                                    $v.sawline.fly_screen_order
                                )
                            }}
                        </div>
                    </div>
                </div>
                <div class="grid grid-cols-4 gap-4">
                    <div class="flex items-center gap-2">
                        <ui5-checkbox
                            :checked="
                                sawline.use_product_image_on_paint_list == 1
                            "
                            @change="
                                sawline.use_product_image_on_paint_list = $event
                                    .target.checked
                                    ? '1'
                                    : '0'
                            "
                        />
                        <ui5-label>
                            {{ labels.use_product_image_on_paint_list }}:
                        </ui5-label>
                    </div>
                </div>
                <div
                    v-for="error in $v.sawline.backendErrors.$model"
                    class="error backend-error"
                >
                    {{ error }}
                </div>
                <div class="sawline-conditions-actions">
                    <div class="sawline-conditions">
                        <template v-if="sawline.parent_id == null">
                            <h3>Als</h3>
                            <div
                                class="sawline-condition"
                                :key="
                                    'condition.' +
                                    sawline.ID +
                                    '.' +
                                    conditionIndex
                                "
                                v-for="(
                                    condition, conditionIndex
                                ) in sawline.conditions.filter(
                                    (x) => x && !x.removed
                                )"
                            >
                                <span>
                                    {{
                                        getDatafieldLabel(
                                            dataFields[condition.datafield]
                                        )
                                    }}
                                    {{ condition.compare }}
                                    {{ condition.cmpValue }}
                                </span>
                                <i
                                    @click="
                                        $delete(
                                            sawline.conditions,
                                            conditionIndex
                                        )
                                    "
                                    class="fa fa-trash-o"
                                ></i>
                                <span
                                    v-if="
                                        dataFields[condition.datafield] &&
                                        dataFields[condition.datafield].inUse ==
                                            0
                                    "
                                    class="inactive-option"
                                    title="Dit dataveld is niet meer in gebruik bij het producttype en kan daardoor ongewenst
              gedrag opleveren"
                                >
                                    !
                                </span>
                            </div>
                            <div
                                class="add-sawline-condition"
                                v-if="getConditionOptions(sawline).length"
                            >
                                <ui5-select
                                    @change="
                                        sawline.selectedConditionToAdd =
                                            $event.detail.selectedOption.value
                                    "
                                >
                                    <ui5-option
                                        :value="conditionIndex"
                                        v-if="condition"
                                        :key="conditionIndex"
                                        v-for="(
                                            condition, conditionIndex
                                        ) in getConditionOptions(sawline)"
                                    >
                                        {{
                                            getDatafieldLabel(
                                                dataFields[condition.datafield]
                                            )
                                        }}
                                        {{ condition.compare }}
                                        {{ condition.cmpValue }}
                                    </ui5-option>
                                </ui5-select>
                                <ui5-button
                                    @click="
                                        sawline.conditions = [
                                            ...sawline.conditions,
                                            getConditionOptions(sawline)[
                                                sawline.selectedConditionToAdd ||
                                                    0
                                            ],
                                        ]
                                    "
                                >
                                    +
                                </ui5-button>
                            </div>
                            <div v-else>
                                Alle mogelijke voorwaarden zijn al met deze
                                zaaglijn verbonden.
                            </div>
                        </template>
                    </div>
                    <div class="sawline-actions">
                        <i
                            class="fa fa-indent"
                            v-if="sawline.parent_id == null"
                            @click.stop.prevent="addChildSawline(sawline.ID)"
                        ></i>
                        <i
                            class="fa fa-copy"
                            @click.stop.prevent="copy(sawline)"
                        ></i>
                        <i
                            class="fa fa-trash-o"
                            @click.stop.prevent="sawline.removed = true"
                        ></i>
                    </div>
                </div>
            </template>
            <div
                v-else
                @click="openLine(sawline)"
            >
                <div class="first-row">
                    <div class="field-grid external-name">
                        {{ sawline.externalName }}
                    </div>
                    <div class="field-grid">
                        {{ getOptionLabel(profileOptions, sawline.profile) }}
                    </div>
                    <div class="field-grid">
                        {{
                            getDatafieldLabel(
                                dataFields[sawline.profileDatafield]
                            )
                        }}
                    </div>
                    <div class="field-grid">
                        {{ sawline.leftEnd }}
                    </div>
                    <div class="field-grid">
                        {{ sawline.rightEnd }}
                    </div>
                </div>
                <div class="second-row">
                    <div class="left-settings">
                        <div class="field-grid">
                            {{
                                getOptionLabel(
                                    dataFieldOptions,
                                    sawline.datafield
                                )
                            }}
                        </div>
                        <div class="field-grid">
                            {{
                                getOptionLabel(
                                    sawlineOperationOptions,
                                    sawline.addition
                                )
                            }}
                        </div>
                        <div class="field-grid">
                            {{ sawline.constant }}
                        </div>
                        <div class="field-grid">
                            {{ sawline.offset }}
                        </div>
                        <div class="field-grid">
                            {{ sawline.divideBy }}
                        </div>
                        <div class="field-grid">
                            {{ getOptionLabel(unitOptions, sawline.unit) }}
                        </div>
                    </div>
                    <div class="right-settings">
                        <ui5-label>{{ labels.datafieldCNC }}:</ui5-label>
                        <div class="field-grid">
                            {{
                                getOptionLabel(
                                    dataFieldOptions,
                                    sawline.datafieldCNC
                                )
                            }}
                        </div>
                        <div class="field-grid">
                            {{
                                getOptionLabel(
                                    sawlineOperationOptions,
                                    sawline.additionCNC
                                )
                            }}
                        </div>
                        <div class="field-grid">
                            {{ sawline.constantCNC }}
                        </div>
                    </div>
                </div>
                <div class="third-row">
                    <ui5-label>
                        {{
                            sawline.sawgroup
                                ? sawGroupNames[sawline.sawgroup]
                                : ''
                        }}
                    </ui5-label>
                    <!--
                        <div class="field-grid">
                            <ui5-label>{{ labels.addBoorCorrection }}:</ui5-label>
                            <div class="static-value">
                                {{
                                    sawline.addBoorCorrection == '1' ? 'Ja' : 'Nee'
                                }}
                            </div>
                        </div>
                    -->
                    <div class="field-grid">
                        <ui5-label>{{ labels.useOnProductlists }}:</ui5-label>
                        <div class="static-value">
                            {{
                                sawline.productlistDefinitionIds
                                    .map(
                                        (x) =>
                                            productlistDefinitionOptions.find(
                                                (o) => o.value == x
                                            ).label
                                    )
                                    .join(', ')
                            }}
                        </div>
                    </div>
                    <div class="field-grid">
                        <ui5-label :title="showPaintlist_tooltip">{{ labels.showPaintlist }}:</ui5-label>
                        <div class="static-value" :title="showPaintlist_tooltip">
                            {{ sawline.showPaintlist == '1' ? 'Ja' : 'Nee' }}
                        </div>
                    </div>
                    <div class="field-grid">
                        <ui5-label :title="showSawlist_tooltip">{{ labels.showSawlist }}:</ui5-label>
                        <div class="static-value" :title="showSawlist_tooltip">
                            {{ sawline.showSawlist == '1' ? 'Ja' : 'Nee' }}
                        </div>
                    </div>
                    <div class="field-grid">
                        <ui5-label>{{ labels.add_sawcut_margin }}:</ui5-label>
                        <div class="static-value">
                            {{ sawline.add_sawcut_margin == '1' ? 'Ja' : 'Nee' }}
                        </div>
                    </div>
                    <div class="field-grid">
                        <ui5-label>{{ labels.show_fly_screen }}:</ui5-label>
                        <div class="static-value">
                            {{ sawline.show_fly_screen == '1' ? 'Ja' : 'Nee' }}
                        </div>
                    </div>
                    <div class="field-grid cnc-program-field">
                        <ui5-label>{{ labels.cnc }}</ui5-label>
                        <div class="static-value">{{ sawline.cnc }}</div>
                    </div>
                </div>
                <div class="fourth-row">
                    <div class="field-grid">
                        <ui5-label>{{ labels.fly_screen_color }}:</ui5-label>
                        <div
                            class="static-value"
                            v-html="getLabelForColor(sawline.fly_screen_color)"
                        ></div>
                    </div>
                    <div class="field-grid">
                        <ui5-label>{{ labels.fly_screen_order }}:</ui5-label>
                        <div class="static-value">
                            {{ sawline.fly_screen_order }}
                        </div>
                    </div>
                </div>
                <div class="grid grid-cols-4 mt-4">
                    <div class="flex items-center gap-2">
                        <ui5-label>
                            {{ labels.use_product_image_on_paint_list }}:
                        </ui5-label>
                        <div class="static-value">
                            {{
                                sawline.use_product_image_on_paint_list == '1'
                                    ? 'Ja'
                                    : 'Nee'
                            }}
                        </div>
                    </div>
                </div>
                <div
                    v-for="error in $v.sawline.backendErrors.$model"
                    class="error backend-error"
                >
                    {{ error }}
                </div>
                <div class="sawline-conditions-actions">
                    <div class="sawline-conditions">
                        <template v-if="sawline.parent_id == null">
                            <h3>Als</h3>
                            <div
                                class="sawline-condition"
                                :key="
                                    'condition.' +
                                    sawline.ID +
                                    '.' +
                                    conditionIndex
                                "
                                v-for="(
                                    condition, conditionIndex
                                ) in sawline.conditions.filter(
                                    (x) => x && !x.removed
                                )"
                            >
                                <span>
                                    {{
                                        getDatafieldLabel(
                                            dataFields[condition.datafield]
                                        )
                                    }}
                                    {{ condition.compare }}
                                    {{ condition.cmpValue }}
                                </span>
                                <span
                                    v-if="
                                        dataFields[condition.datafield] &&
                                        dataFields[condition.datafield].inUse ==
                                            0
                                    "
                                    class="inactive-option"
                                    title="Dit dataveld is niet meer in gebruik bij het producttype en kan daardoor ongewenst
              gedrag opleveren"
                                >
                                    !
                                </span>
                            </div>
                            <div
                                v-if="getConditionOptions(sawline).length == 0"
                            >
                                Alle mogelijke voorwaarden zijn al met deze
                                zaaglijn verbonden.
                            </div>
                        </template>
                    </div>
                    <div class="sawline-actions">
                        <i
                            class="fa fa-indent"
                            v-if="sawline.parent_id == null"
                            @click.stop.prevent="addChildSawline(sawline.ID)"
                        ></i>
                        <i
                            class="fa fa-copy"
                            @click.stop.prevent="copy(sawline)"
                        ></i>
                        <i
                            class="fa fa-trash-o"
                            @click.stop.prevent="sawline.removed = true"
                        ></i>
                    </div>
                </div>
            </div>
            <div v-if="isDebug">
                #{{ sawline.ID }} &lt; #{{ sawline.parent_id }}
            </div>
        </div>
        <sawline-edit
            class="child-sawline"
            :id="'sawline-child-' + sawline.ID + '.' + childIndex"
            ref="sawline-edit"
            v-for="(child, childIndex) in children"
            :key="'sawline-child-' + sawline.ID + '.' + childIndex"
            :conditions="conditions"
            :dataFields="dataFields"
            :dataFieldOptions="dataFieldOptions"
            :profileOptions="profileOptions"
            :profileDatafieldOptions="profileDatafieldOptions"
            :get-datafield-label="getDatafieldLabel"
            :saw-group-names="sawGroupNames"
            :condition-filters="conditionFilters"
            :children="[]"
            :add-child-sawline="addChildSawline"
            :open-line="openLine"
            :selected-line="selectedLine"
            @copy="copy"
            :sawline="child"
        />
    </div>
</template>
<script>
import {
    maxLength,
    minValue,
    requiredIf,
    required,
} from 'vuelidate/lib/validators';
import { isMatchingCondition } from '../../helpers/sawline-common';
import IsDebugMixin from '../../mixins/is-debug';
import LocalizationMixin from '../../mixins/localization';
import ColorSelect from '../ColorSelect';
import { mapGetters } from 'vuex';
import TextInput from '../TextInput.vue';

export default {
    mixins: [IsDebugMixin, LocalizationMixin],
    components: { ColorSelect, TextInput },
    props: [
        'sawline',
        'conditions',
        'dataFields',
        'dataFieldOptions',
        'profileOptions',
        'profileDatafieldOptions',
        'getDatafieldLabel',
        'sawGroupNames',
        'conditionFilters',
        'children',
        'addChildSawline',
        'openLine',
        'selectedLine',
        'productlistDefinitionOptions',
    ],
    mounted() {
        if (!this.sawline.ID) {
            this.$el.scrollIntoView();
        }
    },
    data() {
        return {
            unitOptions: ['st', 'mm', ''].map((x) => {
                return { value: x, label: x };
            }),
            labels: {
                cnc: 'cnc-programma',
                datafieldCNC: 'cnc',
                addBoorCorrection: 'Boorcorrectie toepassen',
                showPaintlist: 'Gebruik op lakbon',
                showSawlist: 'Gebruik op zaaglijst',
                useOnProductlists: 'Gebruik op',
                show_fly_screen: 'Gebruik op vliegenraamtafel',
                fly_screen_color: 'Kleur vliegenraamtafel',
                fly_screen_order: 'Volgorde vliegenraamtafel',
                use_product_image_on_paint_list:
                    'Gebruik productafbeelding op lakbon',
                add_sawcut_margin: 'Marge zaagsnede',
            },
        };
    },
    methods: {
        multiComboboxOnChange(event) {
            const selectedValues = event.detail.items.map((x) =>
                parseInt(x.getAttribute('val'))
            );
        },
        getLabelForColor(value) {
            if (!value) {
                return '';
            }
            const color = this.flyScreenColors.find((x) => x.value == value);
            return color
                ? color.label +
                      ' <span style="color: ' +
                      color.htmlColor +
                      '">&#9632;</span>'
                : '';
        },
        getOptionLabel(options, optionValue) {
            if (!options) {
                return '';
            }
            const option = options.find((x) => x.value == optionValue);
            return option ? option.label : '';
        },
        shouldShowSawline(sawline) {
            const conditionFilters = this.conditionFilters;

            if (!conditionFilters.length) {
                return true;
            }

            return isMatchingCondition(conditionFilters, sawline.conditions);
        },
        copy(sawline) {
            this.$emit('copy', sawline);
        },
        anyError(validator) {
            return {
                'has-error': validator.$anyError,
            };
        },
        hasError(validator) {
            return {
                'has-error': this.getErrorFromValidator(validator).length > 0,
            };
        },
        getErrorFromValidator(validator) {
            if (!validator || !validator.$invalid) {
                return false;
            }

            if (validator.required === false) {
                return 'verplicht';
            }
            if (validator.maxLength === false) {
                return 'maxlengte ' + validator.$params.maxLength.max;
            }
            if (validator.isUnique === false) {
                return 'moet uniek zijn';
            }
            if (validator.minValue === false) {
                return 'min ' + validator.$params.minValue.min;
            }

            return false;
        },
        getConditionOptions(sawline) {
            return this.conditions.filter(
                (x) => x && !x.removed && !sawline.conditions.includes(x)
            );
        },
    },
    computed: {
        ...mapGetters({
            sawlineOperationOptions: 'sawlines/getOperationOptions',
            flyScreenColors: 'sawlines/getFlyScreenColorOptions',
        }),
        showPaintlist_tooltip() {
            return this.trans('product_types.sawlines.tooltips.showPaintlist');
        },
        showSawlist_tooltip() {
            return this.trans('product_types.sawlines.tooltips.showSawlist');
        },
        show_fly_screen_tooltip() {
            return this.trans('product_types.sawlines.tooltips.show_fly_screen');
        },
    },
    watch: {
        'sawline.profile': {
            handler: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.$set(this.sawline, 'profileDatafield', null);
                }
            },
        },
    },
    validations() {
        const incr = this.sawlineOperationOptions.find(
            (x) => x.label == 'incr'
        ).value;
        const requiredIfNotRemoved = requiredIf(function (item) {
            return !item.removed;
        });
        return {
            sawline: {
                ID: {},
                divideBy: {
                    minValue: minValue(1),
                },
                offset: {
                    minValue: minValue(0),
                    required: requiredIf((item) => item.addition == incr),
                },
                fly_screen_order: {
                    minValue: minValue(0),
                    required: requiredIf(
                        (item) => item.show_fly_screen == true
                    ),
                },
                use_product_image_on_paint_list: {
                    //bool
                },
                addition: {
                    //valid option
                },
                constant: {
                    required: requiredIfNotRemoved,
                    maxLength: maxLength(50),
                },
                datafield: {
                    required: requiredIfNotRemoved,
                    //valid option
                },
                additionCNC: {
                    required: requiredIfNotRemoved,
                    //valid option
                },
                constantCNC: {
                    maxLength: maxLength(50),
                },
                datafieldCNC: {
                    //valid option
                },
                externalName: {
                    required: requiredIfNotRemoved,
                    maxLength: maxLength(50),
                },
                profileDatafield: {
                    //valid option
                },
                unit: {
                    //required: required, //empty is a valid option
                    //valid option
                },
                //addBoorCorrection: {
                //required
                //bool
                //},
                profile: {
                    //valid option
                },
                cnc: {
                    maxLength: maxLength(150),
                },
                showPaintlist: {
                    //required
                    //bool
                },
                showSawlist: {
                    //required
                    //bool
                },
                add_sawcut_margin: {
                    //required
                    //bool
                },
                show_fly_screen: {
                    //required
                    //bool
                },
                fly_screen_color: {},
                leftEnd: {
                    required: requiredIfNotRemoved,
                    minValue: minValue(0),
                },
                rightEnd: {
                    required: requiredIfNotRemoved,
                    minValue: minValue(0),
                },
                conditions: {},
                backendErrors: {},
            },
        };
    },
};
</script>
